import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const GooglePlayImg = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../../../images/googlePlayImg.png"
      alt="Encuentra Kolyy app en Google Play"
    />
  );
};

export default GooglePlayImg;
